/**
 * Height of the top bar when visible (mobile only). Keep in sync with landing padding.
 *
 * On its own so a view can clear the bar without importing the bar itself, which
 * brings the account menu and the Redux store with it.
 */
export const TOP_BAR_HEIGHT = 56;
